import { useEffect, useRef } from "react";

function CaptchaCanvas({ text }) {
    const canvasRef = useRef();

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        const width = 120;
        const height = 40;

        ctx.clearRect(0, 0, width, height);

        // Set font to 16px
        ctx.font = "16px Arial";
        ctx.fillStyle = "#000";

        // Random rotation
        const angle = (Math.random() * 0.2) - 0.1;
        ctx.save();                    // Save before rotate
        ctx.translate(10, 25);         // Move origin for centered text
        ctx.rotate(angle);
        ctx.fillText(text, 0, 0);
        ctx.restore();                 // Restore after drawing text

        // Noise (reduced for small canvas)
        for (let i = 0; i < 12; i++) {
            ctx.beginPath();
            ctx.arc(Math.random() * width, Math.random() * height, 1, 0, 2 * Math.PI);
            ctx.fill();
        }

    }, [text]);

    return <canvas ref={canvasRef} width={100} height={30} />;
}

export default CaptchaCanvas;
